/**
 * @param {Array} details – hour detail objects (each with `id`, `status`)
 * @returns {'none'|'all'|'partial'}
 */
export function approvalStatus(details) {
  let submitted = 0;
  let approved = 0;

  for (const d of details) {
    if (d.id !== null) {
      submitted++;
      if (d.status === 'approved') approved++;
    }
  }

  return submitted === 0 ? 'none' : approved === submitted ? 'all' : 'partial';
}
